'use client';

import { Button, Flex, Text } from '@skin-seoul/design-system';
import { useQueryErrorResetBoundary } from '@tanstack/react-query';
import { Suspense, type ReactElement, type ReactNode } from 'react';
import { ErrorBoundary } from './ErrorBoundary';
import { ClientOnly } from './ClientOnly';
interface QueryBoundaryProps {
  children: ReactNode;
  clientOnly?: boolean;
  loadingFallback?: ReactElement;
  errorFallback?: ReactElement;
}
export const DefaultErrorFallback = ({
  resetBoundary
}: {
  resetBoundary?: () => void;
}) => {
  return <Flex direction="column" align="center" gap={4} data-sentry-element="Flex" data-sentry-component="DefaultErrorFallback" data-sentry-source-file="QueryBoundary.tsx">
      <Text textStyle="body2" fontWeight="bold" data-sentry-element="Text" data-sentry-source-file="QueryBoundary.tsx">
        Something went wrong
      </Text>
      <Button value="primary" colorPalette="brand" onClick={resetBoundary} data-sentry-element="Button" data-sentry-source-file="QueryBoundary.tsx">
        Retry
      </Button>
    </Flex>;
};
const QueryBoundary = ({
  children,
  errorFallback,
  loadingFallback,
  clientOnly = false
}: QueryBoundaryProps) => {
  const {
    reset
  } = useQueryErrorResetBoundary();
  if (clientOnly) {
    return <ClientOnly fallback={loadingFallback || <></>}>
        <ErrorBoundary fallback={errorFallback || <DefaultErrorFallback />} resetQuery={reset}>
          <Suspense fallback={loadingFallback || <></>}>{children}</Suspense>
        </ErrorBoundary>
      </ClientOnly>;
  }
  return <ErrorBoundary fallback={errorFallback || <DefaultErrorFallback />} resetQuery={reset} data-sentry-element="ErrorBoundary" data-sentry-component="QueryBoundary" data-sentry-source-file="QueryBoundary.tsx">
      <Suspense fallback={loadingFallback || <></>} data-sentry-element="Suspense" data-sentry-source-file="QueryBoundary.tsx">{children}</Suspense>
    </ErrorBoundary>;
};
export default QueryBoundary;